import React, { useState } from 'react';

interface LifestyleStepProps {
  data?: any;
  onChange: (data: any) => void;
  onNext: (data: any) => void;
  onBack: () => void;
}

const LifestyleStep: React.FC<LifestyleStepProps> = ({ data, onChange, onNext, onBack }) => {
  const [formData, setFormData] = useState({
    smokes: data?.smokes || false,
    drinks_alcohol: data?.drinks_alcohol || false,
    exercises_regularly: data?.exercises_regularly || false,
    exercise_type: data?.exercise_type || '',
    exercise_frequency_per_week: data?.exercise_frequency_per_week ?? '',
  });

  const handleChange = (field: string, value: any) => {
    let updated = { ...formData, [field]: value };
    // If user turns off exercise, clear optional exercise type (iOS sends nil when empty)
    if (field === 'exercises_regularly' && value === false) {
      updated = { ...updated, exercise_type: '' };
    }
    setFormData(updated);
    onChange(updated);
  };

  return (
    <div>
      <h2 className="form-section-title">Lifestyle Details</h2>

      <div className="form-group">
        <label className="checkbox-row">
          <input
            type="checkbox"
            className="form-checkbox"
            checked={formData.smokes}
            onChange={(e) => handleChange('smokes', e.target.checked)}
          />
          <span className="checkbox-label">Smokes</span>
        </label>

        <label className="checkbox-row">
          <input
            type="checkbox"
            className="form-checkbox"
            checked={formData.drinks_alcohol}
            onChange={(e) => handleChange('drinks_alcohol', e.target.checked)}
          />
          <span className="checkbox-label">Drinks Alcohol</span>
        </label>

        <label className="checkbox-row">
          <input
            type="checkbox"
            className="form-checkbox"
            checked={formData.exercises_regularly}
            onChange={(e) => handleChange('exercises_regularly', e.target.checked)}
          />
          <span className="checkbox-label">Exercises Regularly</span>
        </label>
      </div>

      {formData.exercises_regularly && (
        <>
          <div className="form-group">
            <label className="form-label">Exercise Type</label>
            <select
              className="form-select"
              value={formData.exercise_type}
              onChange={(e) => handleChange('exercise_type', e.target.value)}
            >
              <option value="">Select...</option>
              <option value="gym">Gym</option>
              <option value="running">Running</option>
              <option value="yoga">Yoga</option>
              <option value="other">Other</option>
            </select>
          </div>

          <div className="form-group">
            <label className="form-label">Exercise Frequency (per week)</label>
            <input
              type="number"
              className="form-input"
              value={formData.exercise_frequency_per_week === '' || formData.exercise_frequency_per_week == null ? '' : formData.exercise_frequency_per_week}
              onChange={(e) => {
                const v = e.target.value;
                const num = parseInt(v, 10);
                handleChange('exercise_frequency_per_week', v === '' || Number.isNaN(num) ? '' : num);
              }}
              min="0"
              max="14"
              placeholder=""
            />
          </div>
        </>
      )}
    </div>
  );
};

export default LifestyleStep;
